export enum BenefitsFamilies {
    Partner = 'Partner',
    Client = 'Client'
}
